module.exports = __webpack_public_path__ + "fonts/notosans-medium-web.9c9f372.woff2";